/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { toggleFieldOpen } from "data/store/reducers/composer";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { useFieldOpen } from "../../hooks/use-field-open";
// import useFieldZone from 'cms/fields/context/use-field-zone'

const AccordionBottomEdgeToggle = (props) => {
    
    const show = props?.show;
    // const { FieldZoneState, toggleExpanded } = useFieldZone()
    // const { expanded = false } = FieldZoneState || {}
    const dispatch = useDispatch();
    const { field } = useCurrentDynamicField();
    const name = field?.name;
    const { getNamedFieldIsOpen } = useFieldOpen();
    const open = getNamedFieldIsOpen(name);
    
    const onClick = () => {
        dispatch(toggleFieldOpen(field));
    };

    if (!show) {
        return null;
    }

    return (
        <div className='simplicity-component-toggle' onClick={onClick}>
            <div className='simplicity-component-chevron-bar'>
                <hr className="horizontalLine"/>
                {open &&
                    <FontAwesomeIcon icon={"fa-regular fa-chevron-up"} />
                }
                {!open &&
                    <FontAwesomeIcon icon={"fa-regular fa-chevron-down"} />
                }
                <hr className="horizontalLine"/>
            </div>
        
        </div>
    );
};

AccordionBottomEdgeToggle.displayName = "AccordionBottomEdgeToggle";
export { AccordionBottomEdgeToggle };
